import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderMenu from "../components/HeaderMenu";
import "../css/StyleMenuHome.css";
import { Icon } from "@mui/material";

export default function MenuLaporanSafety() {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [userJabatan, setUserJabatan] = useState("");

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            setUserName(userData.nama || "");
            setUserJabatan(userData.jabatan || "");
        }
    }, []);



    return (
        <div className="menu-home-container" style={{ width: "100%" }}>
            <header className="app-header">
                <div className="header-content">
                    <button className="back-button" onClick={() => navigate("/menu")}>
                        <Icon>arrow_back</Icon>
                    </button>
                    <h1 className="header-title"> Laporan Safety</h1>
                    <div className="header-spacer"></div>
                </div>
            </header>
            <div className="menu-home-content">

                <div className="menu-grid">
                    <div className="menu-item" onClick={() => navigate("/form-inspeksi")}>
                        <button className="menu-button">
                            <span className="mdi mdi-clipboard-check menu-icon"></span>
                        </button>
                        <div className="menu-text">Form Inspeksi</div>
                    </div>

                    <div className="menu-item" onClick={() => navigate("/form-observasi")}>
                        <button className="menu-button">
                            <span className="mdi mdi-binoculars menu-icon"></span>
                        </button>
                        <div className="menu-text">Form Observasi</div>
                    </div>
                </div>


            </div>
        </div>
    );
}
